import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import App from './App.js';
import Library from './features/Library.js';
import NotebookView from './features/NotebookView.js';
import PageView from './features/PageView.js';
import SearchView from './features/SearchView.js';
import TasksView from './features/TasksView.js';
import SettingsView from './features/SettingsView.js';
import Diag from './features/Diag.js';
import Trash from './features/Trash.js';
import NewPage from './features/NewPage.js';
import './styles.css';

registerSW({
  immediate: true,
  onRegisteredSW(_url, registration) {
    // Procura versão nova ao abrir e a cada 30 min. Com autoUpdate, assim que
    // ela existe o service worker assume e a próxima navegação já roda o
    // código novo, sem depender de o usuário notar um aviso.
    void registration?.update();
    setInterval(() => void registration?.update(), 30 * 60 * 1000);
  },
});

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Library /> },
      { path: 'c/:notebookId', element: <NotebookView /> },
      { path: 'p/:pageId', element: <PageView /> },
      { path: 'new', element: <NewPage /> },
      { path: 'search', element: <SearchView /> },
      { path: 'tasks', element: <TasksView /> },
      { path: 'settings', element: <SettingsView /> },
      { path: 'diag', element: <Diag /> },
      { path: 'trash', element: <Trash /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
